import Icon from '../icon';
import SimpleButton from 'components/button/simplebutton';
import { userflowSupportTriggerClass } from './constant';

function HelpButton() {
  return <SimpleButton className={userflowSupportTriggerClass} icon={<Icon name="IcoHelp" title="Help" />} />;
}

export default HelpButton;
